module.exports = __webpack_public_path__ + "img/cju_main2.35d95d13.jpg";